import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from 'app/core/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class GrowthRoleGuard implements CanActivate, CanActivateChild {

  constructor(
    private _authService: UserService,
    private _router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let currentUser;
    // Get the current user from auth service
     this._authService.user$.subscribe((user) => {
        currentUser = user;
    })
    
    // If user has growth role and trying to access a path other than geo-audience
    if (currentUser && currentUser.role === 'growth' && !state.url.includes('/geo-audience')) {
      // Redirect to geo-audience
      return this._router.createUrlTree(['/geo-audience']);
    }
    
    // Allow access for non-growth users or if accessing geo-audience
    return true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state);
  }
}
